<template>
  <div class="filiale-customer-page">
    <div class="clear">
      <h2 class="paging-title">子公司客户</h2>
      <button class="btn-default" @click="download">下载</button>
    </div>
    <table class="table">
      <tr>
        <th>注册客户</th>
        <th>所属子公司</th>
        <th>所属大区</th>
        <th>客户联系人</th>
        <th>联系方式</th>
        <th>合同时间</th>
        <th>
          成单金额/元
          <div class="year-dropdown">
            <span class="year el-dropdown-link">{{year}}年</span>
            <el-select v-model="year" size="mini" @change="changeYear">
              <el-option v-for="(item,index) in years" :key="index" :label="item" :value="item" :selected="item==year">{{item}}</el-option>
            </el-select>
          </div>
        </th>
        <th>状态</th>
      </tr>
      <tr v-for="(item,index) in tableData" :key="index">
        <td @click="goto(item.CompanyName)">{{item.CompanyName}}</td>
        <td>{{item.SubCompanyName}}</td>
        <td>{{item.AreaCategory}}</td>
        <td>{{item.LinkMan}}</td>
        <td>{{item.Handset}}</td>
        <td>{{item.SignStartTime}}至{{item.SignEndTime}}</td>
        <td>{{item.CurrentYearJobAmount | formatPrice}}</td>
        <td :class="{'active':item.ActiveStatus==1 || item.ActiveStatus==4,'disabled':item.ActiveStatus==2 || item.ActiveStatus==3}">{{item.ActiveStatusLabel}}</td>
      </tr>
      <tr v-if="tableData.length==0">
        <td class="no-data" colspan="7">暂无数据</td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>
<script>
import {DownWebChildCompanyClientList,GetWebChildCompanyClientList} from '@/scripts/api.js'
export default {
  data(){
    return{
      pageNum:1,
      pageSize:10,
      total:0,
      status:0,//0:全部, 1:活跃, 2:已失效, 3:未生效
      tableData:[],
      year:new Date().getFullYear(),
    }
  },
  computed:{
    companyId(){
      if(this.$store.state.userInfo){
        return this.$store.state.userInfo.LoginAccountId;
      }
      return '';
    },
    years(){
      let year=new Date().getFullYear();
      let arr=[];
      for(let i=year;i>=2000;i--){
        arr.push(i);
      }
      return arr;
    },
  },
  watch:{
    companyId(value,old){
      if(value && value!=old){
        this.loadData();
      }
    }
  },
  created(){
    if(this.companyId){
      this.loadData();
    }
  },
  methods:{
    loadData(){
      GetWebChildCompanyClientList({
        companyId:this.companyId,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        activeStatus:this.status,
        year:this.year,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.total=r.Data.TotalCount;
          this.pageNum=r.Data.PageNum,
          this.tableData=r.Data.Data ||[];
        }
      })
    },
    //切换年份
    changeYear(){
      this.pageNum=1;
      this.tableData=[];
      this.loadData();
    },
    //分页
    pageChange(data){
      this.pageNum=data;
      this.loadData(this.companyId);
    },
    //跳转到客户工单列表
    goto(name){
      this.$router.push({path:'/filialeCustomerOrder',query:{name:name}});
    },
    download(){
      var params=`companyId=${this.companyId}&year=${this.year}`;
      DownWebChildCompanyClientList(params);
    },
  }
}
</script>
<style lang="scss">
.filiale-customer-page{
  .table{
    margin-top: 30px;
    border-collapse: collapse;
    border: 1px solid #e5e5e5;
    width: 100%;
    tr{
      border: 1px solid #e5e5e5;
    }
    th{
      height: 48px;
      line-height: 48px;
      background-color: #f8f8f8;
      font-size:14px;
      color:#333;
      text-align: center;
      min-width: 80px;
      font-weight: normal;
    }
    td{
      height: 48px;
      font-size:14px;
      color:#333;
      text-align: center;
      &:first-child{
        cursor: pointer;
      }
      &.active{
        color:#f75959;
      }
      &.disabled{
        color:#999;
      }
    }
  }
  .year-dropdown{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    .year{
      padding-right: 14px;
      position: relative;
      &:after{
        content:'';
        position: absolute;
        right: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top:6px solid #666;
        margin-top: -2px;
      }
    }
    .el-select{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 9;
      opacity: 0;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 30px;
  }
}
</style>